/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import WebhookEndpointsidWebhookEndpoint from './WebhookEndpointsidWebhookEndpoint';

/**
 * The WebhookEndpointsIdBody model module.
 * @module model/WebhookEndpointsIdBody
 * @version v0.3
 */
export default class WebhookEndpointsIdBody {
  /**
   * Constructs a new <code>WebhookEndpointsIdBody</code>.
   * @alias module:model/WebhookEndpointsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>WebhookEndpointsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WebhookEndpointsIdBody} obj Optional instance to populate.
   * @return {module:model/WebhookEndpointsIdBody} The populated <code>WebhookEndpointsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new WebhookEndpointsIdBody();
      if (data.hasOwnProperty('webhook_endpoint'))
        obj.webhookEndpoint = WebhookEndpointsidWebhookEndpoint.constructFromObject(data['webhook_endpoint']);
    }
    return obj;
  }
}

/**
 * @member {module:model/WebhookEndpointsidWebhookEndpoint} webhookEndpoint
 */
WebhookEndpointsIdBody.prototype.webhookEndpoint = undefined;

